module.exports = __webpack_public_path__ + "static/media/29ADMSPC40.83ca3179.jpg";